namespace nscs.character {
    export class Player {

        sprite:Phaser.Physics.Arcade.Sprite;
        seaKitten_mc:Phaser.GameObjects.Sprite;
        frameName:string = null;
        immortalBlinkingTicker:number = 0;

        pounceLanding:boolean = false;

        isFlagReached:boolean = false;

        private gameplay:nscs.gameplay.Gameplay;

        constructor() {
            this.gameplay = nscs.scene.MainScene.instance.gameplay;

            this.sprite = nscs.scene.MainScene.instance.physics.add.sprite( 0, 0,'objects-atlas');
            this.sprite.setOrigin(0.5, 0);
            this.sprite.setBounce(0);
            this.sprite.setCollideWorldBounds(true);

            this.seaKitten_mc = nscs.scene.MainScene.instance.add.sprite( 0, 0,'objects-atlas');
            this.seaKitten_mc.setOrigin(0.5, 1);
            this.seaKitten_mc['-offsets-'] = {
                'chickette_big':{x:0, y:4},
                'nugget_big':{x:0, y:4},
                'pam_big':{x:0, y:-6}
            };
            this.seaKitten_mc['-offsets-flipped-'] = {
                'chickette_big':{x:0, y:15},
                'nugget_big':{x:0, y:15},
                'pam_big':{x:0, y:25}
            };

            this.sprite.on('animationcomplete', ()=>{this.currAnimComplete = true;});

            this.setup();
        }

        public setup():void {
            this.setCharSize(this.gameplay.charSize);
            this.setSeaKittenise(this.gameplay.seaKitten);
        }

        private remakeFrameName():void {
            this.frameName = this.gameplay.character + "_" + this.gameplay.charSize;
        }

        public updateBodySize():void {
            let bodySizes = {
                'chickette_small':{w:20, h:32},
                'chickette_big':{w:21, h:56},
                'nugget_small':{w:21, h:32},
                'nugget_big':{w:20, h:52},
                'pam_small':{w:16, h:35},
                'pam_big':{w:16, h:60}
            };
            this.sprite.body.setSize(bodySizes[this.frameName].w, bodySizes[this.frameName].h);
        }

        public updateBodyFlipY():void {
            this.sprite.flipY = this.gameplay.isGravityFlipped();
            this.sprite.y += (this.offsetsData["flipped"][this.frameName].y - this.offsetsData["normal"][this.frameName].y) * this.gameplay.gravityDir;
        }

        private readonly offsetsData:object = {
            "flipped": {
                'chickette_small':{x:14, y:7},
                'chickette_big':{x:14, y:4},
                'nugget_small':{x:16, y:7},
                'nugget_big':{x:16, y:4},
                'pam_small':{x:17, y:7},
                'pam_big':{x:17, y:4}
            },
            "normal": {
                'chickette_small':{x:14, y:31},
                'chickette_big':{x:14, y:16},
                'nugget_small':{x:16, y:30},
                'nugget_big':{x:16, y:18},
                'pam_small':{x:17, y:34},
                'pam_big':{x:17, y:12}
            }
        };

        public updateBodyOffset():void {
            let offsets = this.offsetsData[this.gameplay.isGravityFlipped() ? "flipped" : "normal"];
            this.sprite.body.setOffset(offsets[this.frameName].x, offsets[this.frameName].y);
        }

        public setCharSize(charSize:string, playAnimation:boolean = true):void {
            let prevCharSize:string = this.gameplay.charSize;
            this.gameplay.charSize = charSize;
            this.remakeFrameName();

            if (this.gameplay.charSize == "small") {
                this.setSeaKittenise(false);
            }

            this.updateBodyFlipY();
            this.updateBodySize();
            this.updateBodyOffset();

            if (playAnimation) {
                if (prevCharSize != this.gameplay.charSize) {
                    this.playGrowAnimation();
                } else {
                    this.playIdleAnimation();
                }
            }
        }

        public fullyActive():boolean {
            return this.immortalBlinkingTicker == 0 && !this.tempDead && !this.isFlagReached;
        }

        public playPounceAnimation():void {
            this.playAnimation('pounce');
            nscs.sound.SoundManager.getInstance().playSound('whiskSND');
        }

        public playPounceLandAnimation():void {
            if (this.fallenBelowTheWorld) return;

            this.playAnimation('pounceLand');
            nscs.scene.MainScene.instance.gameplay.gameScreen.showDustMC(this.sprite.x,
                this.getFootsWorldY(),
                this.gameplay.charSize=="big"?0.7:0.4, this.gameplay.isGravityFlipped() ? 180 : 0);

            nscs.sound.SoundManager.getInstance().playSound('stompThudSND');
        }

        public playWalkAnimation():void {
            this.playAnimation('walk');
        }

        public playIdleAnimation():void {
            this.playAnimation('idle');
        }

        public playFlyAnimation():void {
            this.playAnimation('fly');
        }

        public playForcedFlyAnimation():void {
            this.playAnimation('fly', true);
        }

        public playClimbingAnimation():void {
            this.playAnimation('climbing');
        }

        public playDeathAnimation(sizeWhenOnDeath:string):void {
            if (sizeWhenOnDeath == 'small') {
                this.playForcedFlyAnimation();
            } else {
                this.playGrowAnimation();
            }
        }

        public playGrowAnimation():void {
            this.playAnimation('grow');
        }

        public setSeaKittenise(active:boolean):void {
            this.gameplay.setSeaKitten(active);
            if (this.gameplay.seaKitten) {
                this.playAnimation('seaKittenise');
            }
        }

        public updateSeaKitten():void {
            if (this.gameplay.charSize == 'big') {
                this.seaKitten_mc.visible = this.gameplay.seaKitten && this.sprite.visible;
                if (this.seaKitten_mc.visible) {
                    this.seaKitten_mc.setFrame(this.sprite.frame.name.replace(this.frameName, 'seaKitten_mc'));
                    this.seaKitten_mc.flipX = this.sprite.flipX;
                    this.seaKitten_mc.flipY = this.sprite.flipY;
                    this.seaKitten_mc.scaleX = this.sprite.scaleX;
                    this.seaKitten_mc.scaleY = this.sprite.scaleY;
                    let _offsets_ = this.seaKitten_mc[this.gameplay.isGravityFlipped() ? '-offsets-flipped-' : '-offsets-'];
                    this.seaKitten_mc.x = this.sprite.x + _offsets_[this.frameName].x;
                    this.seaKitten_mc.y = this.sprite.y + _offsets_[this.frameName].y + this.sprite.height;

                    if (this.currAnim == 'pounce') {
                        this.seaKitten_mc.y -= 10;
                    }

                    if (this.seaKitten_mc.parentContainer != this.sprite.parentContainer
                    ||
                        this.seaKitten_mc.parentContainer.getIndex(this.seaKitten_mc) <= this.sprite.parentContainer.getIndex(this.sprite)
                    ) {
                        if (this.seaKitten_mc.parentContainer) this.seaKitten_mc.parentContainer.remove(this.seaKitten_mc, false);
                        this.sprite.parentContainer.addAt(this.seaKitten_mc, this.sprite.parentContainer.getIndex(this.sprite) + 1);
                    }
                }
            } else {
                this.seaKitten_mc.visible = false;
            }
        }

        tempDead:boolean = false;

        public setTempDead(tempDead:boolean):void {
            this.tempDead = tempDead;
            this.sprite.body.enable = !tempDead;
            this.sprite.setVelocity(0, 0);
        }

        private resetVariables():void {
            this.sideJumpTicker = 0;
            this.pounceLanding = false;
            this.notContactingDownTicker = 0;
            this.fallenBelowTheWorld = false;
            this.contactLeftWithStaticObject = false;
            this.contactRightWithStaticObject = false;
            this.contactDownWithStaticObject = false;
            this.isPlayerLadding = false;
            this.onRespawn = null;
            this.resetFans();
        }

        public minusOneLife():void {
            let prevCharSize:string = this.gameplay.charSize;
            this.setCharSize("small", false);
            this.playDeathAnimation(prevCharSize);
            this.setTempDead(true);
            this.resetVariables();
        }

        public getFootsWorldY():number {
            return this.gameplay.isGravityFlipped() ? this.sprite.y : this.sprite.y + this.sprite.height;
        }

        public setWorldPosition(worldX:number, worldY:number):void {
            this.sprite.setPosition(worldX, worldY - this.sprite.height);
        }

        public onRespawn:()=>void = null;

        public respawn(atX:number, atY:number):void {
            this.setWorldPosition(atX, atY);
            this.setTempDead(false);
            this.setImmortalBlinking();
            if (this.onRespawn) {
                this.onRespawn();
                this.onRespawn = null;
            }
        }

        private topPriorityAnimations:string[] = ['grow', 'seaKittenise', 'pounceLand'];

        private currAnimComplete:boolean = true;
        private currAnim:string = null;
        private playAnimation(anim:string, forced:boolean = false):void {
            if (!forced) {
                if (!this.currAnimComplete) {
                    if (this.topPriorityAnimations.indexOf(this.currAnim) >= 0 || this.topPriorityAnimations.indexOf(anim) >= 0) return;
                }
            }
            if (anim != this.currAnim) {
                this.sprite.anims.stop();
            }
            this.currAnim = anim;
            this.currAnimComplete = false;
            this.sprite.anims.play(nscs.gameplay.Factory.createAnimName(anim, this.frameName), true);
        }

        private sideJumpTicker:number = 0;
        private notContactingDownTicker:number = 0;

        public setImmortalBlinking():void {
            this.immortalBlinkingTicker = 125;
        }

        public fallenBelowTheWorld:boolean = false;
        public contactLeftWithStaticObject:boolean = false;
        public contactRightWithStaticObject:boolean = false;
        public contactDownWithStaticObject:boolean = false;

        private pipeGoing:boolean = false;
        public goInOutPipe(direction:string, dSize:number, onComplete):void {
            let dx:number = 0;
            let dy:number = 0;
            if (direction == "left") dx = -dSize;
            else if (direction == "right") dx = dSize;
            else if (direction == "down") dy = dSize;
            else if (direction == "up") dy = -dSize;

            this.pipeGoing = true;
            this.sprite.body.enable = false;
            this.sprite.setVelocity(0, 0);
            this.sprite.flipX = direction == "left";
            nscs.scene.MainScene.instance.tweens.add({
                targets: this.sprite,
                x: this.sprite.x + dx,
                y: this.sprite.y + dy,
                duration: 500,
                onComplete: ()=>{
                    if (onComplete) onComplete();
                }
            });

            if (direction == "left" || direction == "right") this.playWalkAnimation();
            else if (direction == "down" || direction == "up") this.playIdleAnimation();
        }

        public resetPipeGoing():void {
            this.pipeGoing = false;
            this.sprite.body.enable = true;
        }

        isPlayerLadding:boolean = false;

        private resetFans():void {
            this.fanUp = this.fanDown = this.fanRight = this.fanLeft = false;
        }

        fanUp:boolean = false;
        fanDown:boolean = false;
        fanLeft:boolean = false;
        fanRight:boolean = false;

        private spaceDownTicker:number = 0;
        private jumpForceTicker:number = 10;

        private xVelocityOnJumpMoment:number = 0;

        public update():void {
            if (this.pipeGoing) {
                return;
            }

            this.fallenBelowTheWorld = this.sprite.y + this.sprite.height >= nscs.scene.MainScene.instance.gameplay.worldHeight;

            if (this.immortalBlinkingTicker > 0) {
                this.immortalBlinkingTicker--;
                this.sprite.alpha = 1 - (this.immortalBlinkingTicker % 25) / 25;
            }

            let inputController:nscs.input.InputController = nscs.scene.MainScene.instance.inputController;

            let contactDownAnything:boolean = this.gameplay.isGravityFlipped() ?
                this.sprite.body.blocked.up || this.sprite.body.touching.up :
                this.sprite.body.blocked.down || this.sprite.body.touching.down;

            let contactDown:boolean = contactDownAnything && this.contactDownWithStaticObject;
            let contactLeft:boolean = (this.sprite.body.blocked.left || this.sprite.body.touching.left) && this.contactLeftWithStaticObject;
            let contactRight:boolean = (this.sprite.body.blocked.right || this.sprite.body.touching.right) && this.contactRightWithStaticObject;

            if (contactDown) {
                this.notContactingDownTicker = 0;
            } else {
                this.notContactingDownTicker++;
            }

            let antiGravitySpeedY:number = -18 * this.gameplay.gravityDir;
            if (this.doingBounceJumpTicker > 0) {
                if (this.doingBounceJumpTicker > 1 && contactDownAnything) {
                    this.doingBounceJumpTicker = 0;
                } else {
                    this.doingBounceJumpTicker++;
                }
            }


            if (this.sideJumpTicker == 0) {
                let speedX:number = 0;
                if (contactDown) {
                    let c:number = 8;
                    if (inputController.cursorKeys.left.isDown || input.InputManager.instance.isDown('LEFT')) {
                        speedX = this.sprite.body.velocity.x + ((-this.gameplay.xSpeed) - this.sprite.body.velocity.x) / c;
                        this.sprite.flipX = true; // flip the sprite to the left
                    } else if (inputController.cursorKeys.right.isDown || input.InputManager.instance.isDown('RIGHT')) {
                        speedX = this.sprite.body.velocity.x + (this.gameplay.xSpeed - this.sprite.body.velocity.x) / c;
                        this.sprite.flipX = false; // use the original sprite looking to the right
                    } else {
                        speedX = this.sprite.body.velocity.x*0.9;
                        if (speedX < 1 && speedX > -1) speedX = 0;
                    }
                } else {
                    let newSpd = 0;
                    if (!this.pounceLanding) {
                        newSpd = this.sprite.body.velocity.x;
                        let vx:number = this.sprite.body.velocity.x;
                        let targetVxModule:number = Math.abs(this.xVelocityOnJumpMoment) < this.gameplay.xSpeed * 0.75 ? this.gameplay.xSpeed * 0.75 : Math.abs(this.xVelocityOnJumpMoment);
                        if (this.doingBounceJumpTicker > 1) {
                            targetVxModule = this.gameplay.xSpeed * 1.37;
                        }
                        let div:number = 20;
                        if (inputController.cursorKeys.left.isDown || input.InputManager.instance.isDown('LEFT')) {
                            speedX = vx + (-targetVxModule - vx) / div;
                            this.sprite.flipX = true; // flip the sprite to the left
                        } else if (inputController.cursorKeys.right.isDown || input.InputManager.instance.isDown('RIGHT')) {
                            speedX = vx + (targetVxModule - vx) / div;
                            this.sprite.flipX = false; // use the original sprite looking to the right
                        } else {
                            speedX = newSpd * 0.95;
                        }
                    }
                }
                this.sprite.setVelocityX(speedX);
            } else {
                this.sideJumpTicker--;
                this.sprite.setVelocityX(this.sprite.body.velocity.x*0.99);
            }

            if (this.isPlayerLadding) {
                if (inputController.cursorKeys.up.isDown || input.InputManager.instance.isDown('UP')) {
                    this.sprite.setVelocityY(-this.gameplay.ladderSpeed);
                    this.playClimbingAnimation();
                    this.sprite.setVelocityX(this.sprite.body.velocity.x*0.5);
                } else if (inputController.cursorKeys.down.isDown || input.InputManager.instance.isDown('DOWN')) {
                    this.sprite.setVelocityY(this.gameplay.ladderSpeed);
                    this.playClimbingAnimation();
                    this.sprite.setVelocityX(this.sprite.body.velocity.x*0.5);
                } else {
                    this.sprite.setVelocityY(antiGravitySpeedY);
                    this.sprite.setVelocityX(this.sprite.body.velocity.x*1.1);
                }

                return;
            }

            if (inputController.spaceObj.isDown || input.InputManager.instance.isDown("UP")) {
                if (this.spaceDownTicker != 0 && this.spaceDownTicker < this.jumpForceTicker * 0.5)  {
                    this.doJump(Math.min((this.spaceDownTicker + this.jumpForceTicker * 0.5) / this.jumpForceTicker, 1));
                    this.spaceDownTicker++;
                } else {
                    this.spaceDownTicker = 0;
                }
                if ((inputController.spacePressedDownAndReleased() || input.InputManager.instance.upPressedDownAndReleased()) && contactDown) {
                    inputController.spacePressUsed();
                    input.InputManager.instance.upPressUsed();

                    this.spaceDownTicker = 1;
                    nscs.sound.SoundManager.getInstance().playSound(this.gameplay.inWater ? 'waterjumpSND' : 'jumpSND');
                    this.xVelocityOnJumpMoment = this.sprite.body.velocity.x;
                }

            } else {
                this.spaceDownTicker = 0;
            }

            // jump
            if (inputController.spacePressedDownAndReleased() || input.InputManager.instance.upPressedDownAndReleased()) {
                if (this.gameplay.seaKitten && this.gameplay.inWater && (this.gameplay.isGravityFlipped()?this.sprite.body.velocity.y < 0:this.sprite.body.velocity.y > 0)) {
                    this.doJump(0.5);
                    inputController.spacePressUsed();
                    input.InputManager.instance.upPressUsed();
                    nscs.sound.SoundManager.getInstance().playSound('waterjumpSND');
                } else if (contactLeft || contactRight) {
                    if (this.notContactingDownTicker > 8) {
                        this.doJump(0.75);
                        inputController.spacePressUsed();
                        input.InputManager.instance.upPressUsed();
                        this.sprite.setVelocityX((contactLeft ? 1 : -1) * this.gameplay.xSpeed * 1.5);
                        this.sprite.flipX = !contactLeft;
                        this.sideJumpTicker = 10;

                        nscs.scene.MainScene.instance.gameplay.gameScreen.showDustMC(
                            this.sprite.x + (contactLeft ? -1 : 1) * 10,
                            this.sprite.y + this.sprite.height/2, this.gameplay.charSize=="big"?0.7:0.4,
                            (contactLeft ? 1 : -1) * 90);

                        nscs.sound.SoundManager.getInstance().playSound('wallJumpSND');
                    }
                }
            }

            if (contactDown) {
                if (this.pounceLanding || this.currAnim == 'pounce') {
                    this.playPounceLandAnimation();
                    this.pounceLanding = false;
                }

                if (Math.abs(this.sprite.body.velocity.x) < 35) {
                    this.playIdleAnimation();
                } else {
                    this.playWalkAnimation();
                }
            } else {
                if ((inputController.keyDownPressedDownAndReleased() || input.InputManager.instance.downPressedDownAndReleased()) && (this.gameplay.isGravityFlipped() ? this.sprite.body.velocity.y < this.gameplay.jumpHeight*0.75 : this.sprite.body.velocity.y > -this.gameplay.jumpHeight*0.75)) {
                    if (!(this.gameplay.seaKitten && this.gameplay.inWater)) {
                        this.doJump(0.4);
                        nscs.util.Functions.delayedCall(250, ()=>{
                            if (this.pounceLanding && this.sprite.parentContainer) this.doJump(-1.75);
                        });
                        inputController.keyDownPressUsed();
                        input.InputManager.instance.downPressUsed();
                        if (!this.pounceLanding) {
                            this.playPounceAnimation();
                            this.pounceLanding = true;
                        }
                    }
                } else {
                    if (!contactDownAnything) {
                        if (!this.pounceLanding) {
                            if (!this.gameplay.isGravityFlipped() && this.sprite.body.velocity.y > 0 ||
                                this.gameplay.isGravityFlipped() && this.sprite.body.velocity.y < 0) {
                                if (Math.abs(this.sprite.body.velocity.x) < 35) {
                                    this.playAnimation('idle', true);
                                } else {
                                    this.playAnimation('walk', true);
                                }
                            } else {
                                this.playFlyAnimation();
                            }
                        }
                    }
                }
            }

            if (this.currAnim == 'pounceLand' || this.currAnim == 'pounce') {
                this.sprite.setVelocityX(0);
            }

            if (Math.abs(this.sideJumpVelocity) > 1) {
                this.sprite.setVelocityX(this.sideJumpVelocity);
                this.sideJumpVelocity += (0 - this.sideJumpVelocity) / 10;
            } else {
                this.sideJumpVelocity = 0;
            }

            if (this.fanUp) {
                if (this.pounceLanding) {
                    this.sprite.setVelocityY(this.sprite.body.velocity.y);
                } else {
                    let spdY:number = (-200 * this.gameplay.gravityDir) * this.gameplay.getFanWaterCoefficient();
                    if (
                        this.gameplay.isGravityFlipped() ?
                            this.sprite.body.velocity.y < antiGravitySpeedY && this.sprite.body.velocity.y < spdY :
                            this.sprite.body.velocity.y > antiGravitySpeedY && this.sprite.body.velocity.y > spdY
                    ) {
                        this.sprite.setVelocityY(this.sprite.body.velocity.y + (spdY - this.sprite.body.velocity.y) * 0.1);
                    }
                }

            }
            if (this.fanLeft) {
                if (!this.pounceLanding) {
                    let spdX:number = - this.gameplay.xSpeed * 0.1 * this.gameplay.getFanWaterCoefficient();
                    if (this.sprite.body.velocity.x > spdX) {
                        this.sprite.setVelocityX(this.sprite.body.velocity.x + (spdX - this.sprite.body.velocity.x) * 0.5);
                    }
                }
            }
            if (this.fanRight) {
                if (!this.pounceLanding) {
                    let spdX:number = this.gameplay.xSpeed * 0.1 * this.gameplay.getFanWaterCoefficient();
                    if (this.sprite.body.velocity.x < spdX) {
                        this.sprite.setVelocityX(this.sprite.body.velocity.x + (spdX - this.sprite.body.velocity.x) * 0.5);
                    }
                }
            }

            this.resetFans();

            this.contactLeftWithStaticObject = this.contactRightWithStaticObject = this.contactDownWithStaticObject = false;
        }

        public doJump(powerCoef:number = 1):void {
            this.sprite.setVelocityY(-this.gameplay.jumpHeight * powerCoef * this.gameplay.gravityDir);
        }

        private sideJumpVelocity:number = 0;
        public doSideJump(powerCoef:number = 1):void {
            this.sideJumpVelocity = this.gameplay.xSpeed * powerCoef;
        }

        public doAfterJumpOverEnemy():void {
            this.pounceLanding = false;
            this.doJump(1);
        }

        private doingBounceJumpTicker:number = 0;
        public doBounceJump():void {
            this.doingBounceJumpTicker = 1;
            this.pounceLanding = false;
            this.doJump(1.55);
        }
    }
}

